import { createContext } from 'react';

const UserContext = createContext({ user: {} });

export default UserContext;
